import axios from "axios";

import ROUTES from "shared/config/apiRoutes";
import { API_URL } from "shared/lib/api/setupApi";

import { notifyUnwrap } from "./utils";

export const getZendeskToken = async (payload?: Record<string, any>) =>
  notifyUnwrap(() =>
    axios.post(`${API_URL}${ROUTES.getZendeskToken}`, payload)
  );
